<app-background-image data-state="shipping"></app-background-image>
<app-topbar></app-topbar>
<app-sidebar [showNavigation]="true"></app-sidebar>

<div class="main-content">
    <div class="table-container">
        <h3>Timeline</h3>

        <div *ngIf="loadStatus(events) === 'loading'">Loading...</div>
        <div *ngIf="loadStatus(events) === 'empty'">
            No timeline events yet.
        </div>

        <div *ngIf="loadStatus(events) === 'loaded'">
            <table class="table table-striped" style="cursor:default">
                <colgroup>
                    <col style="width: 70px" />
                    <col style="width: 70px" />
                    <col style="width: 70px" />
                    <col style="width: auto" />
                    <col style="width: auto" />
                    <col style="width: 100px" />
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Start</th>
                        <th scope="col">End</th>
                        <th scope="col">Action</th>
                        <th scope="col">Component</th>
                        <th scope="col">Comments</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let event of events">
                        <td style="cursor:default">
                            <span *ngIf="!event.startTime">--/--</span>
                            <span
                                *ngIf="event.startTime"
                                [title]="event.startTime | date : 'medium'"
                            >
                                {{ event.startTime | date : "dd/MM" }}
                            </span>
                        </td>
                        <td style="cursor:default">
                            <span *ngIf="!event.startTime">--:--</span>
                            <span
                                *ngIf="event.startTime"
                                [title]="event.startTime | date : 'medium'"
                            >
                                {{ event.startTime | date : "HH:mm" }}
                            </span>
                        </td>
                        <td style="cursor:default">
                            <span *ngIf="!event.endTime">--:--</span>
                            <span
                                *ngIf="event.endTime"
                                [title]="event.endTime | date : 'medium'"
                            >
                                {{ event.endTime | date : "HH:mm" }}
                            </span>
                        </td>
                        <td style="cursor:default">{{ event.name }}</td>
                        <td style="cursor:default">
                            <a
                                *ngIf="event.component"
                                [routerLink]="['../components']"
                                [fragment]="event.componentId"
                            >
                                <span style="cursor:pointer">{{ event.component.description }}</span>
                                <span *ngIf="event.component.setNumber" style="cursor:pointer">
                                    {{ event.component.setNumber }}</span
                                >
                                <span *ngIf="event.component.serialNumber" style="cursor:pointer">
                                    {{ event.component.serialNumber }}</span
                                >
                                <span style="cursor:pointer">
                                    (
                                    {{
                                        event.component.batchLoaded == undefined
                                            ? "?"
                                            : event.component.batchLoaded
                                    }}
                                    /
                                    {{ event.component.batchSize }}
                                    )
                                </span>
                            </a>
                        </td>
                        <td style="cursor:pointer">
                            <a
                                *ngIf="event.numComments"
                                class="badge text-bg-info"
                                style="cursor: pointer"
                                (click)="openComments(event)"
                                [fragment]="event.id"
                            >
                                {{ event.numComments }} comments
                            </a>
                            <span
                                class="badge text-bg-light"
                                *ngIf="!event.numComments"
                                style="cursor: not-allowed"
                            >
                                No comments
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
